import { DeleteOutlined } from "@ant-design/icons";
import * as React from "react";
import { ZSecSpecRow } from "src/business/specification/ZSecSpecRow";
import { columnDisplayId } from "src/business/sysData/sysColumns";
import { BlankLink } from "src/components/BlankLink";
import {
  makeMdmActionColumn,
  RenderButtonAction,
} from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const makeSecColumns = (
  disabled: boolean,
  onDelete: (row: ZSecSpecRow) => void,
): RtColumn<ZSecSpecRow>[] => [
  columnDisplayId,
  {
    key: "name",
    title: "Системное название",
    width: "20%",
    render: ({ id, name }) => (
      <BlankLink href={makeUrl(PageUrl.managementSecondSpecCard, { id })}>
        {name}
      </BlankLink>
    ),
  },
  {
    key: "displayName",
    title: "Название",
    width: "20%",
    render: ({ displayName }) => displayName,
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
  },
  {
    key: "linkType",
    title: "Тип связи",
    width: 150,
    render: ({ linkType }) => linkType.label,
  },
  {
    key: "catalogs",
    title: "Трансляция в каталог",
    width: 400,
    render: ({ catalogs }) => {
      if (!catalogs) return "-";
      return catalogs.map(({ id, name }) => (
        <div key={id}>
          <BlankLink href={makeUrl(PageUrl.records, { id })}>{name}</BlankLink>
        </div>
      ));
    },
  },
  makeMdmActionColumn<ZSecSpecRow>({
    key: "delete",
    render: (row) => (
      <RenderButtonAction
        icon={<DeleteOutlined />}
        disabled={disabled}
        onClick={() => onDelete(row)}
      />
    ),
  }),
];
